var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site"},[_c(_vm.sliceType(_vm.document.type),{tag:"component",attrs:{"document":_vm.document,"hreflangs":_vm.hreflangs || {},"url":_vm.canonical}}),_vm._v(" "),_c('script',{attrs:{"type":"application/ld+json"},domProps:{"innerHTML":_vm._s(_vm.jsonld)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }